import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlSigninBunkerUrlCss = baseCss;

const NlSigninBunkerUrlStyle0 = nlSigninBunkerUrlCss;

const NlSigninBunkerUrl = /*@__PURE__*/ proxyCustomElement(class NlSigninBunkerUrl extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlLogin = createEvent(this, "nlLogin", 7);
        this.nlCheckLogin = createEvent(this, "nlCheckLogin", 7);
        this.titleLogin = 'Connect with bunker url';
        this.description = 'Please enter a bunker url provided by key store.';
        this.isGood = false;
    }
    handleInputChange(event) {
        state.nlSigninBunkerUrl.loginName = event.target.value;
        this.nlCheckLogin.emit(event.target.value);
    }
    handleLogin(e) {
        e.preventDefault();
        this.nlLogin.emit(state.nlSigninBunkerUrl.loginName);
    }
    render() {
        return (h(Fragment, { key: '3a422253215916369f1c65894fd90e17732a735e' }, h("div", { key: 'ace79364c3c4c858b43746a5c5e05f925c78402b', class: "p-4 overflow-y-auto" }, h("h1", { key: '1c7cdc50eff87cac91f4387b96f89109ca84f7cd', class: "nl-title font-bold text-center text-2xl" }, this.titleLogin), h("p", { key: 'dd25754386d05d8cc4035e29b9aa555de08756e1', class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, this.description)), h("div", { key: '1684b906cd07ec17d55db1f1f1aad37ba9b72121', class: "max-w-72 mx-auto" }, h("div", { key: 'ec6a77d2793a0e4ea383991ddcc593c8235e3443', class: "relative mb-2" }, h("input", { key: '2f8440550f9db57b131556c5d4e88228cc2db277', onInput: e => this.handleInputChange(e), type: "text", class: "nl-input peer py-3 px-4 ps-11 block w-full border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent", placeholder: "bunker://...", value: state.nlSigninBunkerUrl.loginName }), h("div", { key: '7718e520a18b35bdd89b6c4f835e01c304b9dcbb', class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none" }, h("svg", { key: 'f0c09de6a0cc3040cd7a52815e83318e270706b4', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "2", stroke: this.isGood ? '#00cc00' : 'currentColor', class: "flex-shrink-0 w-4 h-4 text-gray-500" }, h("path", { key: '93069f3407609c925ee8d14bea26245cf12afe9b', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" })))), h("div", { key: '94a2a34d9275dbf6fa9819f71eb819f1fcffcdf0', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: '9bfbaadcac84780014802805aa82ff8b079dd698', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { key: '30534a179e1fbdfd3849de2b7d2dcc9b15351444', titleBtn: "Connect", disabled: state.isLoading, onClick: e => this.handleLogin(e) }, state.isLoading ? (h("span", { slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" })) : (h("svg", { style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" })))))));
    }
    static get style() { return NlSigninBunkerUrlStyle0; }
}, [0, "nl-signin-bunker-url", {
        "titleLogin": [1, "title-login"],
        "description": [1],
        "isGood": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-signin-bunker-url", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-signin-bunker-url":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlSigninBunkerUrl);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlSigninBunkerUrl as N, defineCustomElement as d };

//# sourceMappingURL=nl-signin-bunker-url2.js.map